module.exports = __webpack_public_path__ + "img/W-S02.bf0b7652.jpg";